
import { defineComponent } from 'vue'
import Card from 'primevue/card'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import tabViewDescriptor from '../TenantManagementTabViewDescriptor.json'

export default defineComponent({
    name: 'selection-table',
    components: {
        Card,
        Column,
        DataTable
    },
    props: {
        title: String,
        dataList: Array,
        selectedData: Array
    },
    emits: ['changed'],
    data() {
        return {
            tabViewDescriptor,
            selectedCategories: [] as any
        }
    },
    watch: {
        selectedData() {
            this.selectedCategories = this.selectedData
        }
    },
    created() {
        this.selectedCategories = this.selectedData
    },
    methods: {
        setDirty() {
            this.$emit('changed', this.selectedCategories)
        },
        onSelectAll(event) {
            this.selectedCategories = event.data
            this.$emit('changed', this.selectedCategories)
        },
        onUnselectAll() {
            this.selectedCategories = []
            this.$emit('changed', this.selectedCategories)
        }
    }
})
